import React from 'react'
import './TableHeader.scss'

const TableHeader = () => {
  const headers = [
    'Code',
    'Order',
    'Comments',
    'Time',
    'Location',
    'Driver',
    'Picker',
    'Picking',
    'Delivery',
    'Van',
    'Status',
    'Payment',
    'Debt',
    'Paid',
    'Total',
  ]
  return (
    <div className='table-header'>
      {headers.map((item, idx) => (
        <div className='table-header__cell' key={idx}>
          {item}
        </div>
      ))}
    </div>
  )
}

export default TableHeader
